
export function awaitTimeout({ms, seconds}) {
  return new Promise((resolve) => setTimeout(resolve, (ms ?? 0) + (seconds ?? 0) * 1000));
}
